import React from "react";

import Typography from "@mui/material/Typography";

import type { MeetingReportFeedItemDataSharing } from "@app/analytics/Home/types";

import Stack, { StackProps } from "@rui/Stack";
import { Bold } from "@rui/styles";

type SharedAlertProps = MeetingReportFeedItemDataSharing & StackProps;

const SharedAlert = ({
  sharee,
  sharer,
  sharedAt: _,
  sx,
  ...stackProps
}: SharedAlertProps) => {
  return (
    <Stack
      sx={{
        ...sx,
        backgroundColor: "shades.primary.100",
        color: "shades.primary.700",
      }}
      padding={1}
      {...stackProps}
    >
      <Typography variant="labelReg">
        <Bold>{sharer}</Bold> shared to <Bold>{sharee}</Bold>
      </Typography>
    </Stack>
  );
};

export default SharedAlert;
